import React from 'react';

import { api } from '../../../../../core/api';
import CompanyTabContent from '../shared/CompanyTabContent';
import { useCompanyTabLoader } from '../shared/useCompanyTabLoader';
import OwnershipHoldings from './OwnershipHoldings';
import OwnershipManagers from './OwnershipManagers';
import OwnershipOwners from './OwnershipOwners';

const CompanyOwnership: React.FC = () => {
  const { data, isLoading } = useCompanyTabLoader(api.company.getOwnershipData);

  return (
    <CompanyTabContent isLoading={isLoading}>
      <OwnershipOwners data={data?.ownerDetail} />
      <OwnershipManagers data={data?.managerDetail} />
      <OwnershipHoldings data={data?.holdingDetail} />
    </CompanyTabContent>
  );
};

export default CompanyOwnership;
